import { Fragment } from "react";
import "./faqs.scss";

///////////////////Desktop
import LeftSideBarComponent from "../../structure_components/desktop_screens/left_sideBar_component/left_sideBar_component";
import HeaderComponent from "../../structure_components/desktop_screens/header_component/header_component";

///////Mobile////////////////////
import MobileLeftSideBarComponent from "../../structure_components/mobile_screens/mobile_left_sideBar_component/mobile_left_sideBar_component";
import MobileHeaderComponent from "../../structure_components/mobile_screens/mobile_header_component/mobile_header_component";
import MobileRightSideBarComponent from "../../structure_components/mobile_screens/mobile_right_sideBar_component/mobile__right_sideBar_component";

import FaqsContentComponent from "./faqs_content_component/faqs_content_component";

//Redux
import { connect } from "react-redux";

const Faqs = (props) => {
  let { history, userData, userPreference } = props;

  const isMob = () => {
    if (window.innerWidth <= 480) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <Fragment>
      <div className="faqs_wrapper">
        <div className="faqs_inner_wrapper">
          {isMob() ? (
            /////for Mobile Screens////////////////////
            <Fragment>
              <MobileLeftSideBarComponent />
              <MobileHeaderComponent
                userPreference={userPreference}
                userData={userData}
              />
              <MobileRightSideBarComponent history={history} />
              <FaqsContentComponent />
            </Fragment>
          ) : (
            /////for Screens greater than Mobile Screens////////////////////
            <Fragment>
              <div className="faqs_right_wrapper">
                <FaqsContentComponent />
              </div>
            </Fragment>
          )}
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.auth.user,
    userPreference: state.userPreference,
  };
};

export default connect(mapStateToProps)(Faqs);
